import { Injectable } from "@angular/core";
import { Apollo } from "apollo-angular";
import { Observable } from "rxjs";
import { ErrorsInterface } from "../errors/errors-interface";
import removeDraftMutation from "./mutations/remove-draft";
import { RemovedPayloadInterface } from "../removed-payload/removed-payload-interface";
import { FetchResult } from '@apollo/client/core';

interface RemoveDraftResponse {
  task: {
    removePermanentlyDraft: {
      output: RemovedPayloadInterface;
      errors: ErrorsInterface;
    };
  };
}

@Injectable()
export class RemoveDraftService {
  constructor(private apollo: Apollo) {}

  remove(id): Observable<FetchResult<RemoveDraftResponse>> {
    return this.apollo.mutate<RemoveDraftResponse>({
      mutation: removeDraftMutation,
      variables: {
        id,
      },
    });
  }
}
